import MAddRitualCard from './MAddRitualCard.vue';

export { MAddRitualCard };
export default MAddRitualCard;
